import React, { useEffect, useState } from "react";
import { FxDashChart2ConsProd } from "./components/FxDashChart2ConsProd";
import { FxDashChart2Cons } from "./components/FxDashChart2Cons";
import { FxDashChart3 } from "./components/FxDashChart3";
import { FxDashChart4 } from "./components/FxDashChart4";
import { FxmsData } from "../fxms/datas/FxData";
import { FxRenderer } from "../fxms/datas/FxRenderer";
import { FxmsPopup } from "../fxms/windows/FxWindows";
import { FxResource } from "../fxms/inputs/FxResource";
import { FxmsContentDashboardDialog, FxWindow } from "../fxms/windows/FxWindows";
import { NavLink, useParams } from "react-router-dom";
import { DetailModal } from "./VupComDash_1";
import { getFirstDayOfMonth, getYesterday, toKSTISOString } from "./common/commonMethod";
// import { WeatherInfo } from "./components/WeatherInfo";
import Button from '@mui/material/Button'
import moment from "moment/moment";
import "../css/VUP_dash.css";
import Modal from "@mui/material/Modal";

/*공장대시보드*/
export const PlantDash = (props) => {
  const opObjUi = FxmsData.getOpObj("ui-3-3");


  let plantInloNo = MyPlantInloNo(props);
  console.log("plantInloNo공장 >> ", plantInloNo);

  const inlo = FxmsData.getInlo(plantInloNo);

  function MyPlantInloNo(props) {
    const { plantInloNo } = useParams();
    if (plantInloNo === undefined) {
      return JSON.parse(localStorage.getItem("plantInfoJson")).inloNo;
    }
    return plantInloNo;
  }

  const [dataList0, setDataList0] = useState({}); //알림
  const [dataList1, setDataList1] = useState({}); //실시간에너지사용현황
  const [dataList2, setDataList2] = useState({}); //당월누적요금
  const [dataList2_2, setDataList2_2] = useState({}); // 전월 사용량(비교군)
  const [dataList3, setDataList3] = useState({}); //계측기현황
  const [dataList4, setDataList4] = useState({}); //당일전력사용량
  const [dataList5_1, setDataList5_1] = useState({}); //실시간 전력 사용 현황(당일)
  const [dataList5_2, setDataList5_2] = useState({}); //실시간 전력 사용 현황(전일)
  const [dataList6, setDataList6] = useState({}); //공지사항 (오늘 기준 2주)
  const [dataList7, setDataList7] = useState({}); //에너지절감량
  const [dataList8, setDataList8] = useState({}); //당월누적요금
  const [inputData, setInputData] = useState({});
  const [period, setPeriod] = useState(""); // 전일자까지 표시 
  const [detailModal, setDetailModal] = useState(false);
  const [measurModal, setMeasurModal] = useState(false);
  const [clickedEng, setClickedEng] = useState("");
  const [clickedCnt, setClickedCnt] = useState("");
  const [cmModalOpen, setCmModalOpen] = useState(false);
  const [cmboardPopObj, setCmboardPopObj] = useState({}); //공지사항 팝업
  const [feModalOpen, setFeModalOpen] = useState(false);
  const [feboardPopObj, setFeboardPopObj] = useState({}); //정비사항 팝업
  const [openDetailViewAir, setOpenDetailViewAir] = useState(false); //실시간 그래프 상세 팝업
  const [openDetailViewSteam, setOpenDetailViewSteam] = useState(false);
  const [openDetailViewGas, setOpenDetailViewGas] = useState(false);
  const [openDetailViewEpwr, setOpenDetailViewEpwr] = useState(false);

  const [alarmCurrent, setAlarmCurrent] = useState(0);  //알림 슬라이드를 위한 변수
  // const [plantInloNo, setPlantInloNo] = useState('');
  const [complex, setComplex] = useState({});
  const [dialogOpen, setDialogOpen] = useState(false);
  const [remoteModal, setRemoteModal] = useState(false);
  const [remoteEngId, setRemoteEngId] = useState("");
  const [remoteData, setRemoteData] = useState({});
  const [remoteStatuses, setRemoteStatuses] = useState({});
  const [airYn, setAirYn] = useState(false);
  const [steamYn, setSteamYn] = useState(false);
  const [epwrYn, setEpwrYn] = useState(false);
  const [gasYn, setGasYn] = useState(false);

    // 시간 포맷팅 함수 수정
  const formatPsDate = (psDate) => {
    if (!psDate) return '';

    // psDate를 문자열로 변환
    const psDateStr = String(psDate);

    const year = psDateStr.substring(0, 4);
    const month = psDateStr.substring(4, 6);
    const day = psDateStr.substring(6, 8);
    const hour = psDateStr.substring(8, 10);
    const minute = psDateStr.substring(10, 12);

    return `${year}년 ${month}월 ${day}일 ${hour}:${minute} 기준`;
  };

  const closeCmModal = () => {
    setCmModalOpen(false);
  };

  const closeFeModal = () => {
    setFeModalOpen(false);
  };

  const detailPopupClose = () => {
    setDetailModal(false);
  };

  const cmboardPopup = () => {
    for (let attr of cmboardPopObj.attrList) {
      if (attr.attrName === "ge_postStrtDate") attr.attrDftVal = "day,-14";
    }
    setCmModalOpen(true);
  };

  const feboardPopup = () => {
    for (let attr of feboardPopObj.attrList) {
      if (attr.attrName === "mntnStrtDateStart") attr.attrDftVal = "day,-14";
    }
    setFeModalOpen(true);
  };

  const getTodayTotal = (engId) => {
    // return dataList1[engId] === undefined ? 0 : dataList1[engId].total;
    return dataList1[engId] === undefined ? 0
      : isNaN(dataList1[engId].total) ? "-"
        : dataList1[engId].total.toLocaleString("ko-KR");
  };

  const getAlarmNodtify = () => {
    let idx = alarmCurrent;
    if (alarmCurrent == dataList0.length) {
      setAlarmCurrent(0);
      idx = 0;
    }

    return (
      <ul className="notice">
        <div
          className="notice_container"
          style={{ transform: `translateY(-${30 * idx}px)` }}
        >
          {dataList0.map((item, idx) => {
            return (
              <li className="notice_content" key={idx}>
                <div>
                  <div 
                    className="notice_title" 
                    onClick={() => {
                      FxWindow.showNavigator(opObjUi.menuFullName);
                      setDialogOpen(true);
                    }}
                    style={{ cursor: 'pointer' }}
                  >
                    {item["moName"]}에서 {item["alarmMsg"]}- (
                    {FxRenderer.renderDate(item["occurDtm"])})-
                    {item["inloName"]}
                  </div>
                </div>
              </li>
            );
          })}
        </div>
      </ul>
    );
  };

  const getChartleftVal = (engId, options = {}) => {
    const {
      units = []
    } = options;

    let values = {
      prodInstVal: 0,
      prodPresVal: 0,
      prodTempVal: 0,
      consInstVal: 0,
      consPresVal: 0,
      consTempVal: 0
    };

    if (dataList1[engId]?.length) {
      const lastData = dataList1[engId].at(-1);
      values = {
        prodInstVal: lastData.prodInstVal,
        prodPresVal: lastData.prodPresVal,
        prodTempVal: lastData.prodTempVal,
        consInstVal: lastData.consInstVal,
        consPresVal: lastData.consPresVal,
        consTempVal: lastData.consTempVal
      };
    }

    // 각 에너지원별 특성에 맞게 표시
    const isAir = engId === "AIR";
    const isSteam = engId === "STEAM";
    const isWater = engId === "COOLWATER";

    const renderValue = (type) => {
      const instValue = values[`${type}InstVal`];
      const presValue = values[`${type}PresVal`];
      const tempValue = values[`${type}TempVal`]; 

      return (
        <span className="ml20">
          {instValue === undefined ? 0 : instValue}
          {units[0] && (
            <span 
              className="unit" 
              dangerouslySetInnerHTML={{ __html: units[0] }}
            />
          )}
          
          <span className="ml10">
            {isWater 
              ? (tempValue === undefined ? 0 : tempValue)
              : (presValue === undefined ? 0 : presValue)
            }
          </span>
          {units[1] && (
            <span 
              className="unit" 
              dangerouslySetInnerHTML={{ __html: units[1] }}
            />
          )}
          
          {isSteam && (
            <>
              <span className="ml10">
                {tempValue === undefined ? 0 : tempValue}
              </span>
              {units[2] && (
                <span 
                  className="unit" 
                  dangerouslySetInnerHTML={{ __html: units[2] }}
                />
              )}
            </>
          )}
        </span>
      );
    };

    const isSoruce= (engId === "AIR" && inlo.airSource==='Y') || (engId === "STEAM" && inlo.steamSource==='Y');
    const isSink= (engId === "AIR" && inlo.airSink==='Y') || (engId === "STEAM" && inlo.steamSink==='Y');

    return (
      <div>
        <ul>
          {isSoruce &&
          <li>
            <b>공급</b>
            {renderValue('prod')}
          </li>}
         
          {isSink &&
            <li>
              <b>사용</b>
              {renderValue('cons')}
            </li>
          }
        </ul>
      </div>
    );
  };

  const getMonthTotalCons = (engId) => {
    if (engId !== undefined)
        // return dataList2[engId] === undefined ? 0 : dataList2[engId][0].usageVal.toLocaleString("ko-KR");
      return dataList2[engId] === undefined ? 0
          : isNaN(dataList2[engId][0].consUsageVal) ? "-"
              : dataList2[engId][0].consUsageVal.toLocaleString("ko-KR");
    else
      return Object.keys(dataList2).length === 0 ? 0
          : isNaN(dataList2.monthTotal) ? "-"
          : dataList2.monthTotal.toLocaleString("ko-KR");
  };

  const getMonthTotalProd = (engId) => {
    if (engId !== undefined)
        // return dataList2[engId] === undefined ? 0 : dataList2[engId][0].usageVal.toLocaleString("ko-KR");
      return dataList2[engId] === undefined ? 0
          : isNaN(dataList2[engId][0].prodUsageVal) ? "-"
              : dataList2[engId][0].prodUsageVal.toLocaleString("ko-KR");
    else
      return Object.keys(dataList2).length === 0 ? 0
          : isNaN(dataList2.monthTotal) ? "-"
          : dataList2.monthTotal.toLocaleString("ko-KR");
  };

  const getLastMonthAmt = (engId) => {
    if (dataList2_2[engId] !== undefined) {
      return dataList2_2[engId]
    } else {
      return 0;
    }
  };

  const consAmtPercent = (engId) => {
    let thisMonStr = getMonthTotalCons(engId);
    let thisMon = 0;
    let lastMon = 0;

    if (thisMonStr) thisMon = parseInt(thisMonStr?.replace(/,/g, ''), 10) || 0;
    lastMon = parseInt(getLastMonthAmt(engId)) || 0;
    if (lastMon < 0) lastMon = 0;

    if (lastMon !== 0) {
      return isNaN(thisMon) || thisMon === 0 ? 0
        : (thisMon / (lastMon * 1.02)) * 100;
    } else if (thisMon === 0) return 0;
    else return 40;
  }

  const prodAmtPercent = (engId) => {
    let thisMonStr = getMonthTotalProd(engId);
    let thisMon = 0;
    let lastMon = 0;

    if (thisMonStr) thisMon = parseInt(thisMonStr?.replace(/,/g, ''), 10) || 0;
    lastMon = parseInt(getLastMonthAmt(engId)) || 0;
    if (lastMon < 0) lastMon = 0;

    if (lastMon !== 0) {
      return isNaN(thisMon) || thisMon === 0 ? 0
        : (thisMon / (lastMon * 1.02)) * 100;
    } else if (thisMon === 0) return 0;
    else return 40;
  }

  const getMeasur = (engId) => {
    let totCnt = 0;
    let onCnt = 0;
    let offCnt = 0;
    let engName =
      engId === "EPWR" ? "전기" : engId === "AIR" ? "압축공기" : "스팀";

    if (Object.keys(dataList3).length !== 0 && dataList3[engId] !== undefined) {
      totCnt = dataList3[engId][0].totCnt;
      onCnt = dataList3[engId][0].onCnt;
      offCnt = dataList3[engId][0].offCnt;
      engName = engId === "AIR" ? '압축공기' : dataList3[engId].engName;
    }
    return (
      <>
        <tr>
          <td>{engName}</td>
          <td>
            <div className="numBoxGroup">
              <div className="numBox mr20">
                <span>전체</span>
                <div className="num">
                  <a
                    id={engId}
                    href="#"
                    className="num"
                    onClick={() => clickHandler(engId, "totalCnt")}
                  >
                    {totCnt}
                  </a>
                </div>
              </div>
              <div className="numBox mr20">
                <span>정상</span>
                <div className="num">
                  <a
                    id={engId}
                    href="#"
                    className="num"
                    onClick={() => clickHandler(engId, "onCnt")}
                  >
                    {onCnt}
                  </a>
                </div>
              </div>
              <div className="numBox">
                <span>이상</span>
                {complex.length !== 0 ? (
                  <div className="num">
                    <a
                      id={engId}
                      href="#"
                      className="num"
                      onClick={() => clickHandler(engId, "offCnt")}
                    >
                      {offCnt}
                    </a>
                  </div>
                ) : (
                  <>
                    <div className="num">{onCnt}</div>
                  </>
                )}
              </div>
            </div>
          </td>
        </tr>
      </>
    );
  };

  const getDayData = () => {
    let data = {};

    if (dataList4["EPWR"] === undefined || dataList4["EPWR"].length === 0) {
      data.consAmtSum = 0;
      data.consAmtNow = 0;
      data.consAmtMax = 0;
    } else {
      data = dataList4["EPWR"];
    }

    return (
      <>
        <h4>당일 전력 사용량</h4>
        <div className="dataGroup">
          <div className="numBigSize">
            {data.consAmtSum}
            <span className="unit">&nbsp;&nbsp;kWh</span>
          </div>
        </div>
        <h4>현재 전력 부하</h4>
        <div className="dataGroup">
          <div className="numBigSize">
            {data.consAmtNow}
            <span className="unit">&nbsp;&nbsp;kW&nbsp;&nbsp;&nbsp;</span>
          </div>
        </div>
        <h4>당일 전력 피크</h4>
        <div className="dataGroup">
          <div className="numBigSize">
            {data.consAmtMax}
            <span className="unit">&nbsp;&nbsp;kW&nbsp;&nbsp;&nbsp;</span>
          </div>
        </div>
      </>
    );
  };

  const getBoard = (board) => {
    const boardHtml = [];

    if (Object.keys(dataList6).length !== 0 && dataList6[board].length !== 0) {
      for (let i = 0; i < dataList6[board].length; i++) {
        boardHtml.push(
          <tr>
            <td>
              {board === "CMBOARD" ?
                <a
                  href="#"
                  className="bbs"
                  onClick={() => {
                    setCmModalOpen(true);
                  }}
                > {dataList6[board][i]?.boardTitle}
                </a>
                :
                <a
                  href="#"
                  className="bbs"
                  onClick={() => {
                    setFeModalOpen(true);
                  }}
                > {dataList6[board][i]?.mntnCnts}  {/* 정비내용*/}
                </a>}
            </td>
            <td>
              {board === "CMBOARD" ?
                <>
                  {moment(dataList6[board][i]?.postFnshDate, "YYYYMMDD").format("YYYY.MM.DD")}
                </>
                :
                <>
                  {moment(dataList6[board][i]?.mntnResvStrtDate, "YYYYMMDD").format("YYYY.MM.DD")}
                </>
              }
            </td>
          </tr>
        );
      }
    }
    return boardHtml;
  };

  const HARD_CODED_VALUES = {
    AIR: [
      { consMonth: "202410", expConsAmt: 37548, consAmt: 21626 },
      { consMonth: "202411", expConsAmt: 38078, consAmt: 20353 },
      { consMonth: "202412", expConsAmt: 39665, consAmt: 20369 },
      { consMonth: "202501", expConsAmt: 31034, consAmt: 18307 },
      { consMonth: "202502", expConsAmt: 33577, consAmt: 19815 },
      { consMonth: "202503", expConsAmt: 36810, consAmt: 21674 },
      { consMonth: "202504", expConsAmt: 37937, consAmt: 21692 },
      { consMonth: "202505", expConsAmt: 33554, consAmt: 20213 },
      { consMonth: "202506", expConsAmt: 32633, consAmt: 20591 },
      { consMonth: "202507", expConsAmt: 33807, consAmt: 18170 },
      { consMonth: "202508", expConsAmt: 33630, consAmt: 18164 },
      { consMonth: "202509", expConsAmt: 32157, consAmt: 21983 },
      { consMonth: "202510", expConsAmt: 37115, consAmt: 22563 },
    ],
    STEAM: [
      { consMonth: "202501", expConsAmt: 29, consAmt: 8 },
      { consMonth: "202502", expConsAmt: 29, consAmt: 10 },
      { consMonth: "202503", expConsAmt: 27, consAmt: 9 },
      { consMonth: "202504", expConsAmt: 23, consAmt: 8 },
      { consMonth: "202505", expConsAmt: 22, consAmt: 8 },
      { consMonth: "202506", expConsAmt: 21, consAmt: 7 },
      { consMonth: "202507", expConsAmt: 21, consAmt: 10 },
      { consMonth: "202508", expConsAmt: 72, consAmt: 31 },
      { consMonth: "202509", expConsAmt: 108, consAmt: 35 },
      { consMonth: "202510", expConsAmt: 159, consAmt: 56 },
    ],
  };

  const shouldUseHardcodedSaveRate = (engId) => {
    const ownerNo = String(inlo?.ownerInloNo ?? "").trim();
    const energyCode = String(engId ?? "").trim().toUpperCase();
    return (
      (ownerNo === "11000" && energyCode === "AIR") ||
      (ownerNo === "14000" && energyCode === "STEAM")
    );
  };

  const getHardcodedSaveRateData = (engId) => {
    if (!shouldUseHardcodedSaveRate(engId)) {
      return null;
    }

    const values = HARD_CODED_VALUES[engId];
    if (!Array.isArray(values) || values.length === 0) {
      return null;
    }

    const saveTotal = values.reduce(
      (sum, value) => sum + (Number(value.expConsAmt || 0) - Number(value.consAmt || 0)),
      0
    );
    const expTotal = values.reduce((sum, value) => sum + Number(value.expConsAmt || 0), 0);

    return {
      saveValue: saveTotal.toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }),
      saveRate: expTotal === 0 ? "-" : ((saveTotal / expTotal) * 100).toFixed(2),
      startDate: moment(values[0].consMonth, "YYYYMM").format("YYYY.MM"),
      endDate: moment(values[values.length - 1].consMonth, "YYYYMM").format("YYYY.MM"),
    };
  };

  const getSaveRate = (engId, unit) => {
    let saveValue = 0;
    let saveRate = "-";
    let startDate = "";
    let endDate = "";
    const hardcoded = getHardcodedSaveRateData(engId);

    if (hardcoded) {
      saveValue = hardcoded.saveValue;
      saveRate = hardcoded.saveRate;
      startDate = hardcoded.startDate;
      endDate = hardcoded.endDate;
    } else {
      if (dataList7[engId] === undefined) return null;
      else if (dataList7[engId].length !== 0) {
        // saveValue = dataList7[engId].saveTotal.toFixed(2);
        saveValue = dataList7[engId].saveTotal
        .toLocaleString(undefined, {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        })
        saveRate = dataList7[engId].saveRate.toFixed(2);
        startDate = moment(dataList7[engId].startDate, "YYYYMM").format(
          "YYYY.MM"
        );
        endDate = moment(dataList7[engId].endDate, "YYYYMM").format("YYYY.MM");
      }
    }
    return (
      <p className="saveRateLine">
        <span className="saveRateLeadDot" aria-hidden="true"></span>
        <span className="saveRateLabel">절감량</span>
        <span className="saveRateValue">
          : {saveValue}&nbsp;
          <span
            className="unit"
            dangerouslySetInnerHTML={{ __html: unit }}
          ></span>
        </span>
        <span className="saveRateDivider" aria-hidden="true"></span>
        <span className="saveRateLabel">절감률</span>
        <span className="saveRateValue">
          : {isFinite(saveRate) && !isNaN(saveRate) ? saveRate : "-"}&nbsp;
          <span className="unit">%</span>
        </span>
        <span className="saveRateDivider" aria-hidden="true"></span>
        <span className="saveRateLabel">산출기간</span>
        <span className="saveRateValue">: {startDate}~{endDate}</span>
      </p>
    );
  };

  /*당월 누적 요금 상세내역 팝업*/
  const getdetailPopupData = () => {
    let usageAmtAir = 0;
    let usageAmtStaem = 0;
    let usageAmtCoolwater = 0;

    let data = dataList2;

    if (data["AIR"] !== undefined) {
      // usageAmtAir = data["AIR"][0].usageAmt.toLocaleString("ko-KR");
      if(isNaN(data["AIR"][0].consUsageAmt)){
        usageAmtAir = "데이터 없음";
      }else{
        usageAmtAir = data["AIR"][0].consUsageAmt.toLocaleString("ko-KR");
      }
    }

    if (data["STEAM"] !== undefined) {
      // usageAmtStaem = data["STEAM"][0].usageAmt.toLocaleString("ko-KR");

      if(isNaN(data["STEAM"][0].consUsageAmt)){
        usageAmtStaem = "데이터 없음";
      }else{
        usageAmtStaem = data["STEAM"][0].consUsageAmt.toLocaleString("ko-KR");
      }
    }

    if (data["COOLWATER"] !== undefined) {
      // usageAmtCoolwater = data["COOLWATER"][0].usageAmt.toLocaleString("ko-KR");

        if(isNaN(data["COOLWATER"][0].consUsageAmt)){
          usageAmtCoolwater = "데이터 없음";
        }else{
          usageAmtCoolwater = data["COOLWATER"][0].consUsageAmt.toLocaleString("ko-KR");
        }
    }

    return (
      <>
        <tr>
          <td className="unit fs20">압축공기</td>
          <td className="dataGroup">
            <div className="numBigSize">
              {usageAmtAir}
              <span className="unit fs20">&nbsp;원</span>
            </div>
          </td>
        </tr>
        <tr>
          <td className="unit fs20">스팀</td>
          <td className="dataGroup">
            <div className="numBigSize">
              {usageAmtStaem}
              <span className="unit fs20">&nbsp;원</span>
            </div>
          </td>
        </tr>
        <tr>
          <td className="unit fs20">냉수</td>
          <td className="dataGroup">
            <div className="numBigSize">
              {usageAmtCoolwater}
              <span className="unit fs20">&nbsp;원</span>
            </div>
          </td>
        </tr>
      </>
    );
  };

  const handleComplexChange = (e) => {
    setComplex(e.target.value);
  };

  //const plantInloNo = '11108';

  let engList = FxmsData.getDatas("energy");

  /**
   * 대시보드 데이터 가져오기
   */

  async function showDatas_1() {
    /* 0. 알림 */
    let para = {};
    para.inloNo = plantInloNo;
    const list0 = await FxmsData.GET("fxAlAlarm/cur/list", para);
    setDataList0(list0.data);
    setAlarmCurrent(0);
  }

  async function showDatas_2(inputData) {
    const para = inputData ? { ...inputData } : {};

    /* 1. 실시간에너지 사용현황 : 에너지 사용 조회 */
    const list1 = await FxmsData.GET("vup/dash/energy/list", para);
    let tmpDataList = {};

    
    engList.push({engDescr:"15분전기",engId:"EPWR_15",engName:"15분전기"})
    tmpDataList = getEnergyDataList(list1.data);
    tmpDataList = getTodayEneryCostAmt(tmpDataList);
    setDataList1(tmpDataList);

    /* 3. 계측기현황 : 계측기 상태 조회 */
    const list3 = await FxmsData.GET("vup/dash/sensor/state", para);
    tmpDataList = {};
    tmpDataList = getEnergyDataList(list3.data.sensor_state_list);
    setDataList3(tmpDataList);

    /* 4. 당일 전력사용량 : 에너지 일간 사용 통계 */
    //para.plantInloNo = '12106';  // 테스트용
    const list4 = await FxmsData.GET("vup/dash/energy/stat", para);
    tmpDataList = {};
    tmpDataList["EPWR"] = list4.data.filter((i) => i.engId === "EPWR")[0];
    setDataList4(tmpDataList);

    /* 5. 실시간 전력 사용 현황 : 에너지 사용 조회(당일) */
    const list5_1 = await FxmsData.GET("vup/dash/energy/list", para);
    tmpDataList = {};
    tmpDataList = getEnergyDataList(list5_1.data, "EPWR")["EPWR"];
    setDataList5_1(tmpDataList);

    /* 5. 실시간 전력 사용 현황 : 에너지 사용 조회(전일) */
    let yesterday = getYesterday();
    let yesterdayStr = yesterday.replaceAll("-", "");
    para.startDate = yesterdayStr;
    para.endDate = yesterdayStr;

    const list5_2 = await FxmsData.GET("vup/dash/energy/list", para);
    tmpDataList = {};
    tmpDataList = getEnergyDataList(list5_2.data, "EPWR");

    let tmp = tmpDataList["EPWR"].map((i) => {
      var d = i.psDate + "";
      i.psDate = parseInt(inputData.startDate + d.substr(8, 13));
      return i;
    });
    setDataList5_2(tmp);  
  }

  async function showDatas_3(para) {
    // 16시간 리프레시
  }

  async function showDatas_4(para) {
    // 리프레시 안함
    /* 2. 당월누적요금 : 에너지 월간 사용 금액 조회 */
    const thisMonth = getToday("yyyymm")
    const lastMonth = getPrevMonth("yyyymm")

    let yesterDay = getYesterday().replaceAll("-", "");

    const param1 = {
      plantInloNo: para?.plantInloNo,
      month: thisMonth,
      day : yesterDay
    }
    const param2 = {
      plantInloNo: para?.plantInloNo,
      month: lastMonth
      // month: 202305      
    }

    const list2 = await FxmsData.GET("vup/dash/energy/amount", param1);
    const list2_2 = await FxmsData.GET("vup/dash/energy/amount", param2);

    let tmpDataList = {};
    let tmpDataList2 = {};

    tmpDataList = getEnergyDataList(list2.data);
    tmpDataList.monthTotal = list2.data.reduce(function (total, cur) {
      if (cur.engId === 'STEAM' || cur.engId === 'COOLWATER' || cur.engId === 'AIR' || cur.engId === 'EPWR'|| cur.engId === 'GAS') {
        total = total + cur.consUsageAmt;
      }
      return total;
    }, 0);

    setDataList2(tmpDataList);

    // 전 달 에너지 사용량
    tmpDataList2 = list2_2.data;
    tmpDataList2.forEach(item => {
      const engId = item.engId;
      const consUsageVal = item.consUsageVal || 0;

      if (engId) {
        tmpDataList2[engId] = (tmpDataList2[engId] || 0) + consUsageVal;
      }
    });
    setDataList2_2(tmpDataList2);

    /* 6. 공지사항, 정비계획 조회 */
    let date = new Date(); 
    let filter = {};
    filter.le_postStrtDate = toKSTISOString(new Date()).replaceAll("-", "");
    filter.ge_postStrtDate = toKSTISOString(new Date(date.setDate(date.getDate() - 13))).replaceAll("-", "");
    filter.inloNo = plantInloNo;
    const list6_1 = await FxmsData.GET("fxCmBoard/list2", filter);

    filter.mntnResvStrtDate = filter.ge_postStrtDate;
    filter.mntnResvFnshDate = filter.le_postStrtDate;
    delete filter.le_postStrtDate;
    delete filter.ge_postStrtDate; // 프로퍼티 삭제

    const queryString = `filter=${encodeURIComponent(JSON.stringify(filter))}`;
    const url = `vup/select_3_2?${queryString}`;
    const list6_2 = await FxmsData.GET(url);

    tmpDataList = {};
    tmpDataList["CMBOARD"] = list6_1.data;
    tmpDataList["FEBOARD"] = list6_2.data.filter((i) => i.mntnFnshYn === 'N');
    setDataList6(tmpDataList);

    /* 7. 에너지절감량 : 에너지 일단위 소비현황 */
    date = new Date();
    para.endMonth = toKSTISOString(new Date(date.setMonth(date.getMonth() - 1))).slice(0, 7).replaceAll("-", "");

    const startDate = new Date();
    startDate.setMonth(startDate.getMonth() - 12); // 현재 월부터 12개월 전
    para.startMonth = toKSTISOString(startDate).slice(0, 7).replaceAll("-", "");
    const list7 = await FxmsData.GET("vup/dash/energy/monthly", para);

    tmpDataList = {};
    let tmp = {};
    tmp = getEnergyDataList(list7.data);
    tmpDataList = getSaveDataList(tmp);
    setDataList7(tmpDataList);


  }
  function getToday(param) {
    //오늘날짜 가져오기 yyyymmdd | yyyymm | yyyy | mm
    var date = new Date();
    var year = date.getFullYear();
    var month = ("0" + (1 + date.getMonth())).slice(-2);
    var day = ("0" + date.getDate()).slice(-2);

    if (param === "yyyymmdd") {
      return year + month + day;
    } else if (param === "yyyymm") {
      return year + month;
    } else if (param === "yyyy") {
      return year;
    } else if (param === "mm") {
      return month;
    } else {
      return year + month + day;
    }
  }

  function getPrevMonth(param) {
    // 전월(mm)
    var date = new Date();
    var year = date.getFullYear();
    var month = date.getMonth() + 1; // 현재 월
    var prevMonth = month - 1; // 전월

    // 현재 월이 1월인 경우
    if (prevMonth === 0) {
      year -= 1; // 전년도
      prevMonth = 12; // 12월
    }

    if (param === "yyyymm") {
      return year + ("0" + prevMonth).slice(-2);
    } else if (param === "mm") {
      return ("0" + prevMonth).slice(-2);
    } else {
      return year + ("0" + prevMonth).slice(-2);
    }
  }

  function dataSort(arr) {
    arr.sort(function (a, b) {
      return a.psDate - b.psDate;
    });
  }

  function getEnergyDataList(data, engId) {
    let engDataLists = {};

    dataSort(data);

    if (engId != null) {
      engDataLists[engId] = data.filter((i) => i.engId === engId);
    } else {
      
      for (let e of engList) {
        let engDataList = data.filter((i) => i.engId === e.engId);
        if (engDataList.length !== 0) {
          engDataLists[e.engId] = engDataList;
          engDataLists[e.engId].engName = e.engName;
        }
      }
    }
    return engDataLists;
  }

  function getTodayEneryCostAmt(data) {
    let engDataLists = { ...data };
    for (let e of engList) {
      if (engDataLists[e.engId] !== undefined) {
//        console.log(e.engId,"전체: ",engDataLists[e.engId])
        const todayCostTotal = data[e.engId].reduce(function (total, cur) {
//          console.log(" cur.consAmt>>",e.engId,": ", cur.consAmt);
          total = total + cur.consAmt || 0;
          return total;
        }, 0);
        engDataLists[e.engId].total = todayCostTotal;
      }
    }
    return engDataLists;
  }

  function getSaveDataList(data) {
    let engDataLists = { ...data };
    for (let e of engList) {
      if (engDataLists[e.engId] !== undefined) {
        engDataLists[e.engId].saveTotal = data[e.engId].reduce(function (
          total,
          cur
        ) {
          total = total + (cur.expConsAmt - cur.consAmt);
          return total;
        },
          0);
        engDataLists[e.engId].saveExptotal = data[e.engId].reduce(function (
          total,
          cur
        ) {
          total = total + cur.expConsAmt;
          return total;
        },
          0);
        engDataLists[e.engId].saveRate =
          (data[e.engId].saveTotal / data[e.engId].saveExptotal) * 100;
        engDataLists[e.engId].startDate = engDataLists[e.engId].at(0).consMonth;
        engDataLists[e.engId].endDate = engDataLists[e.engId].at(-1).consMonth;
      }
    }
    return engDataLists;
  }

  useEffect(() => {
    // 데이터가 로드될 때까지 기다린 후 실행
    const checkDataLoaded = () => {
      const inloData = FxmsData.getDatas("inlo");
      if (inloData && inloData.length > 0) {
        // 데이터가 로드된 후 실행
        executePlantDash();
      } else {
        // 100ms 후 다시 확인
        setTimeout(checkDataLoaded, 100);
      }
    };
      checkDataLoaded();
    }, []);
  
  const executePlantDash = () => {
    let inputData = {};
    /* 기본 파라미터 : 날짜, 공장코드 등 */
    const firstDay = getFirstDayOfMonth();
    let firstDayStr = firstDay.replaceAll("-", ".");
  
    let today = new Date();
    const todayStr = toKSTISOString(today);
  
    let date = todayStr.replaceAll("-", ".");
  
    let yesterday = getYesterday();
    yesterday = yesterday.replaceAll("-", ".");
  
    setPeriod(firstDayStr + " ~ " + (todayStr === firstDay ? firstDay : yesterday));
    date = date.replaceAll(".", "");
    inputData = {
      startDate: date,
      endDate: date,
      plantInloNo: plantInloNo,
      day: date,
    };
  
    setInputData(inputData);
    showDatas_1();
    showDatas_2(inputData);
    //showDatas_3(inputData);
    showDatas_4(inputData);
  
    const plant = FxmsData.getDatas("inlo", {
      inloClCd: "PLANT",
      inloNo: plantInloNo,
    });

    setComplex(plant[0]);
  
    let plantNm = "";
    if (plant.length !== 0) plantNm = plant[0].plantInloName;
    else {
      plantNm = "해당 공장 없음";
    }
    FxWindow.showNavigator(plantNm);
    
    let obj = FxmsData.getOpObj("ui-board");
    if (obj) {
      obj.maxWidth = "xl";
      setCmboardPopObj(obj);
    }
  
    obj = FxmsData.getOpObj("ui-3-2");
    if (obj) {
      obj.maxWidth = "xl";
      setFeboardPopObj(obj);
    }
  };
  
  useEffect(() => {
    const refreshAlarm1 = setInterval(() => {
      setAlarmCurrent((alarmCurrent) => alarmCurrent + 1);
    }, 5000); 
    return () => clearInterval(refreshAlarm1);
  }, []);


  useEffect(() => {

    if(inlo.inloNo !==null ){
      inlo.airSource==='Y' || inlo.airSink==='Y' ? setAirYn(true): setAirYn(false);
      inlo.steamSource==='Y' || inlo.steamSink==='Y' ? setSteamYn(true): setSteamYn(false);
      inlo.epwrSource==='Y' || inlo.epwrSink==='Y' ? setEpwrYn(true): setEpwrYn(false);
      inlo.gasSource==='Y' || inlo.gasSink==='Y' ? setGasYn(true): setGasYn(false);
    }  
  }, [inlo]);


  /* 주석 삭제 시 리프레시 실행 */
  /*useEffect(() => {
    //[1000*60*10 : 10분, 1000*15 : 15초, 1000*60*60*6 : 6시간]
    const refreshDashBoard15sec = setInterval(() => {
      showDatas_1();
      console.log("plant_refreshDashBoard15sec:", new Date().toLocaleString());
    }, 1000*15);
    return () => clearInterval(refreshDashBoard15sec);
  }, [inputData]);

  useEffect(() => {
    const refreshDashBoard10min = setInterval(()=>{
      showDatas_2(inputData);
      console.log('refreshDashBoard1min: ' , new Date().toLocaleString())
    },1000*60) ;
    return () => clearInterval(refreshDashBoard10min) ;
  }, [inputData]);*/

  // useEffect(() => {
  //    const refreshDashBoard6hour = setInterval(()=>{
  //     showDatas_3(inputData);
  //     console.log('refreshDashBoard6hour: ' , new Date().toLocaleString())
  //   },1000*15) ;
  //   return () => clearInterval(refreshDashBoard6hour) ;
  // }, [inputData]);

  function clickHandler(engId, click_cnt) {
    setClickedEng(engId);
    setClickedCnt(click_cnt);
    setMeasurModal(!measurModal);
  }

  // 공통 컴포넌트 추가
  const EnergyUsageInfo = ({ title, value, unit }) => (
    <p>
      <span>{title}</span>
      <span><b>{value}</b> {unit}</span>
    </p>
  );

  // 데이터 포맷팅 함수 추가 
  const formatEnergyData = (data, engId) => {
    if (!data[engId]) {
      return {
        dailyUsage: 0,
        currentLoad: 0
      };
    }
    
    return {
      dailyUsage: data[engId].consAmtSum || 0,
      currentLoad: data[engId].consAmtNow || 0,
      currentLoad2: data[engId].consDiffAmtNow || 0
    };
  };

  const getTodayTotalProd = (engId) => {
    if (dataList1[engId] === undefined) return 0;
    
    const total = dataList1[engId].reduce((sum, data) => {
      return sum + (data.prodAmt || 0);
    }, 0);

    return isNaN(total) ? "-" : Math.round(total).toLocaleString("ko-KR");
  };

  const getTodayTotalCons = (engId) => {
    if (dataList1[engId] === undefined) return 0;
    
    const total = dataList1[engId].reduce((sum, data) => {
      return sum + (data.consAmt || 0);
    }, 0);

    return isNaN(total) ? "-" : Math.round(total).toLocaleString("ko-KR");
  };

  const getDailySupplyDemand = (engId, options = {}) => {
    const {
      units = []
    } = options;

    return (
      <div>
        <ul>
          <li>
            <span>공급</span>
            <span className="ml20">
              {getTodayTotalProd(engId)}
              {units[0] && (
                <span 
                  className="unit" 
                  dangerouslySetInnerHTML={{ __html: units[0] }}
                />
              )}
            </span>
          </li>
          <li>
            <span>사용</span>
            <span className="ml20">
              {getTodayTotalCons(engId)}
              {units[0] && (
                <span 
                  className="unit" 
                  dangerouslySetInnerHTML={{ __html: units[0] }}
                />
              )}
            </span>
          </li>
        </ul>
      </div>
    );
  };

  useEffect(() => {
    if(remoteModal === true){
      // 데이터 조회
      FxmsData.GET("vup/dash/valve/status", {
        plantInloNo: plantInloNo,
        engId: remoteEngId
      }).then(response => {
        setRemoteData(response.data);
        
        // collectedValue 값에 따라 초기 상태 설정 (숫자 타입으로 비교)
        const initialStatuses = {};
        response.data.forEach(device => {
          initialStatuses[device.devicePid] = device.collectedValue === 1 ? 'open' : 'close';
        });
        setRemoteStatuses(initialStatuses);
      }).catch(error => {
        console.error("Error fetching remote data:", error);
        setRemoteData([]); 
      });
    } else {
      setRemoteData([]); 
      setRemoteStatuses({}); 
    }
  }, [remoteModal]);

  const remotePopupClose = () => {
    setRemoteModal(false);
  };

  const handleRemoteStatusChange = (devicePid, value) => {
    setRemoteStatuses(prev => ({
      ...prev,
      [devicePid]: value === '1' ? 'open' : 'close'
    }));
  };

  const onClickRemote = (devicePid) => {
    const status = remoteStatuses[devicePid];
    const device = remoteData.find(d => d.devicePid === devicePid);
    
    if (!device) {
      FxWindow.alert("디바이스 정보를 찾을 수 없습니다.", false);
      return;
    }
  
    const params = {
      factoryPid: device.factoryPid,
      devicePid: device.devicePid,
      pointPid: device.pointPid,
      value: status === 'open' ? '1' : '0'
    };
  
    // API 호출
    FxmsData.GET("vup/dash/valve/control", params)
      .then(response => {
        FxWindow.alert("밸브 제어가 실행되었습니다.", false);
      })
      .catch(error => {
        FxWindow.confirm("제어실패하였습니다.\n재시도 하시겠습니까?", function (bRet) {
          if (bRet === false) return;
          onClickRemote(devicePid); // 재시도
        }); 
      });
  };

  const getEnergyName = (engId) => {
    switch(engId) {
      case 'STEAM':
        return '스팀';
      case 'AIR':
        return '압축공기';
      case 'COOLWATER':
        return '냉수';
      case 'EPWR':
        return '전기';
      case 'GAS':
          return '가스';
      default:
        return engId;
    }
  };

  const divAirGraph = [ <div className="gb_title">
    <h2 className="mb20 realtimeEnergyTitle" onClick={() => {
      setOpenDetailViewAir(true);
    }}>실시간 에너지 압축공기 현황</h2>
    {openDetailViewAir && (
      <Modal
        open={openDetailViewAir}
        onClose={() => setOpenDetailViewAir(false)}
        className="detail-chart-modal"
      >
        <div className="detail-chart-container">
          <div className="predict" style={{ height: '100%' }}>
            <div className="vupNewLayerPop">
              <div className="lpopTitle">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', padding: '0 20px' }}>
                  <h3>실시간 에너지 압축공기 현황 상세 차트</h3>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                    <span style={{
                      fontSize: '13px',
                      color: '#999',
                      whiteSpace: 'nowrap',
                      marginRight: '100px'
                    }}>
                      {dataList1.hasOwnProperty('AIR')  > 0 && formatPsDate(dataList1.AIR[dataList1.AIR.length - 1].psDate)}
                    </span>
                    <div className="closeBtn" onClick={() => setOpenDetailViewAir(false)}>
                      <img src="../svgCloseBtn_on.svg" />
                      <img src="../svgCloseBtn.svg" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="lpopContent detail-chart" style={{ height: 'calc(100% - 40px)' }}>
              <FxDashChart2ConsProd
                  key={"AIR"}
                  energy={"AIR"}
                  allValues={dataList1}
                  isDetailView={true}
                  onDetailView={() => setOpenDetailViewAir(true)}
                   />
              </div>
            </div>
          </div>
        </div>
      </Modal>
    )}
    <div className="dataBoxGroup double">
      <div className="full">
        <div className="factoryChart noFlex realtimeEnergyLift">
          <div className="flexData">
            <a onClick={() => {
              setRemoteModal(!remoteModal);
              setRemoteEngId("AIR");
            }}>압축공기</a>
            {getChartleftVal("AIR", {
              units: ["&nbsp;Nm<sup>3</sup>/h,", "&nbsp;bar"]
            })}
          </div>
          <div className="mt20 realtimeEnergyChartWrap">
            <FxDashChart2ConsProd
              key={"AIR"}
              energy={"AIR"}
              allValues={dataList1}
              onDetailView={() => setOpenDetailViewAir(true)}
            />
          </div>
        </div>
      </div>
    </div>
  </div>];

  const divSteamGraph = [<div className="gb_title">
    <h2 className="mb20 realtimeEnergyTitle" onClick={() => {
      setOpenDetailViewSteam(true);
    }} >실시간 에너지 스팀 현황</h2>
    {openDetailViewSteam && (
      <Modal
        open={openDetailViewSteam}
        onClose={() => setOpenDetailViewSteam(false)}
        className="detail-chart-modal"
      >
        <div className="detail-chart-container">
          <div className="predict" style={{ height: '100%' }}>
            <div className="vupNewLayerPop">
              <div className="lpopTitle">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', padding: '0 20px' }}>
                  <h3>실시간 에너지 스팀 현황 상세 차트</h3>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                    <span style={{
                      fontSize: '13px',
                      color: '#999',
                      whiteSpace: 'nowrap',
                      marginRight: '100px'
                    }}>
                      {dataList1.hasOwnProperty('STEAM')  > 0 && formatPsDate(dataList1.STEAM[dataList1.STEAM.length - 1].psDate)}
                    </span>
                    <div className="closeBtn" onClick={() => setOpenDetailViewSteam(false)}>
                      <img src="../svgCloseBtn_on.svg" />
                      <img src="../svgCloseBtn.svg" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="lpopContent detail-chart" style={{ height: 'calc(100% - 40px)' }}>
                <FxDashChart2ConsProd
                  key={"STEAM"}
                  energy={"STEAM"}
                  allValues={dataList1}
                  isDetailView={true}
                  onDetailView={() => setOpenDetailViewSteam(true)}
                />
              </div>
            </div>
          </div>
        </div>
      </Modal>
    )}
    <div className="dataBoxGroup double">
      <div className="full">
        <div className="factoryChart noFlex realtimeEnergyLift">
          <div className="flexData">
            <a onClick={() => {
              setRemoteModal(!remoteModal);
              setRemoteEngId("STEAM");
            }}>스팀</a>
            {getChartleftVal("STEAM", {
              units: ["&nbsp;kg/h,", "&nbsp;bar,", "&nbsp;ºC"]
            })}
          </div>
          <div className="mt20 realtimeEnergyChartWrap">
            <FxDashChart2ConsProd
              key={"STEAM"}
              energy={"STEAM"}
              allValues={dataList1}
              onDetailView={() => setOpenDetailViewSteam(true)}
            />
          </div>
        </div>
      </div>
    </div>
  </div>];

  const divEpwrGraph = [ <div className="gb_title">
  <h2 className="mb20 realtimeEnergyTitle" onClick={() => {
    setOpenDetailViewEpwr(true);
  }} >실시간 사업장 전력 사용 현황</h2>
  {openDetailViewEpwr && (
    <Modal
      open={openDetailViewEpwr}
      onClose={() => setOpenDetailViewEpwr(false)}
      className="detail-chart-modal"
    >
      <div className="detail-chart-container">
        <div className="predict" style={{ height: '100%' }}>
          <div className="vupNewLayerPop">
            <div className="lpopTitle">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', padding: '0 20px' }}>
                <h3>실시간 사업장 전력 사용 현황 상세 차트</h3>
                <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                  <span style={{
                    fontSize: '13px',
                    color: '#999',
                    whiteSpace: 'nowrap',
                    marginRight: '100px'
                  }}>                    
                    {dataList1.hasOwnProperty('EPWR') > 0 && formatPsDate(dataList1.EPWR[dataList1.EPWR.length - 1].psDate)}
                  </span>
                  <div className="closeBtn" onClick={() => setOpenDetailViewEpwr(false)}>
                    <img src="../svgCloseBtn_on.svg" />
                    <img src="../svgCloseBtn.svg" />
                  </div>
                </div>
              </div>
            </div>
            <div className="lpopContent detail-chart" style={{ height: 'calc(100% - 40px)' }}>
            <FxDashChart2Cons
                key={"EPWR"}
                energy={"EPWR"}
                allValues={dataList1}
                isDetailView={true}
                onDetailView={() => setOpenDetailViewEpwr(true)}
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )}
  <div className="vupFlexDataEnd">
   
  </div>
  <div className="chartAreaBig realtimeEnergyChartWrap" onClick={() => setOpenDetailViewEpwr(true)} style={{ cursor: 'pointer' }}>
     <FxDashChart2Cons
      key={"EPWR_15"}
      energy={"EPWR_15"}
      allValues={dataList1}
      onDetailView={() => setOpenDetailViewEpwr(true)}
    /> 
  </div>
  </div>
];

const divGasGraph = [<div>
  <h2 onClick={() => {
    setOpenDetailViewGas(true);
  }}>실시간 사업장 가스 사용 현황</h2>
  {openDetailViewGas && (
    <Modal
      open={openDetailViewGas}
      onClose={() => setOpenDetailViewGas(false)}
      className="detail-chart-modal"
    >
      <div className="detail-chart-container">
        <div className="predict" style={{ height: '100%' }}>
          <div className="vupNewLayerPop">
            <div className="lpopTitle">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', padding: '0 20px' }}>
                <h3>실시간 사업장 가스 사용 현황 상세 차트</h3>
                <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                  <span style={{
                    fontSize: '13px',
                    color: '#999',
                    whiteSpace: 'nowrap',
                    marginRight: '100px'
                  }}>
                    {dataList1.hasOwnProperty('GAS') && formatPsDate(dataList1.GAS[dataList1.GAS.length - 1].psDate)}
                  </span>
                  <div className="closeBtn" onClick={() => setOpenDetailViewGas(false)}>
                    <img src="../svgCloseBtn_on.svg" />
                    <img src="../svgCloseBtn.svg" />
                  </div>
                </div>
              </div>
            </div>
            <div className="lpopContent detail-chart" style={{ height: 'calc(100% - 40px)' }}>
            <FxDashChart2Cons
                key={"GAS"}
                energy={"GAS"}
                allValues={dataList1}
                isDetailView={true}
                onDetailView={() => setOpenDetailViewGas(true)} />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )}
  <div className="vupFlexDataEnd">
    <EnergyUsageInfo
      title="현재 가스사용 부하"
      value={formatEnergyData(dataList4, "GAS").currentLoad}
      unit={<>Nm<sup>3</sup>/h</>}
    />
  </div>
  <div className="chartAreaBig" onClick={() => setOpenDetailViewGas(true)} style={{ cursor: 'pointer' }}>
    <FxDashChart2Cons
      key={"GAS"}
      energy={"GAS"}
      allValues={dataList1}
      onDetailView={() => setOpenDetailViewGas(true)}
    />
  </div>
  </div>
]

  const makeRealtimeAirSteamHtml = () => {

    return (<>
      {airYn && steamYn ?
        <><div className="grayBox span2">
          {divAirGraph}
        </div>
          <div className="grayBox span2">
            {divSteamGraph}
          </div></> :
        airYn ? <div className="grayBox span4">
          {divAirGraph}
        </div> :
          steamYn && <div className="grayBox span4">
            {divSteamGraph}
          </div>} </>
    )
  }

  
  const makeRealtimeEpwrGasHtml = () => {

    return (<>
      {epwrYn && gasYn ?
        <><div className="grayBox span2">
          {divEpwrGraph}
        </div>
          <div className="grayBox span2">
            {divGasGraph}
          </div></> :
        epwrYn ? <div className="grayBox span4">
          {divEpwrGraph}
        </div> :
          gasYn && <div className="grayBox span4">
            {divGasGraph}
          </div>} </>
    )
  }

  return (
    <div id="wrapper">
      <div id="dashPart">
      {/* <WeatherInfo/> */}
        <div className="alertMessage">
          <span>알림</span>
          {Object.keys(dataList0).length !== 0 && dataList0 !== undefined ? (
            getAlarmNodtify()
          ) : (
            <p>발생된 알람이 없습니다.</p>
          )}
          {complex && 
          Object.keys(complex).length !== 0 && 
          complex.complexInloNo && 
          complex.companyInloName ? (
            <select
              value={complex.complexInloNo}
              onChange={handleComplexChange}
            >
              <option value={complex.complexInloNo}>
                {complex.companyInloName}
              </option>
            </select>
          ) : (
            <></>
          )}
          <NavLink to={"/comp-vup-complex-dash/" + complex.complexInloNo}>
            <button>이동</button>
          </NavLink>
        </div>
        <FxmsContentDashboardDialog
          open={dialogOpen}
          closeModal={() => setDialogOpen(false)}
          dialogTitle={'설비관리/알림조회'}
          opObj={opObjUi}
        >
          <FxResource menu={opObjUi}/>
        </FxmsContentDashboardDialog>
        <div className="gridGroup mb20">
        {makeRealtimeAirSteamHtml()}                 
          {remoteModal === true ? (
            <Modal
              open={true}
              onClose={remotePopupClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <div className="">          
                <div className="predict">
                  <div className="vupNewLayerPop minSize">
                    <div className="lpopTitle">
                      <strong>{getEnergyName(remoteEngId)} 밸브 제어</strong>
                      <div className="closeBtn" onClick={remotePopupClose}>
                        <img src="../svgCloseBtn_on.svg" />
                        <img src="../svgCloseBtn.svg" />
                      </div>
                    </div>
                    <div className="lpopContent">
                    {Array.isArray(remoteData) && remoteData.length > 0 ? (
                      remoteData.map((device) => (
                        <div key={device.devicePid}>
                          <h4>{device.deviceNm}</h4>
                          <div className="inRadioGroup">
                            <p>
                              <input 
                                type="radio" 
                                name={`status-${device.devicePid}`}
                                value="1" 
                                onChange={(e) => handleRemoteStatusChange(device.devicePid, e.target.value)} 
                                checked={remoteStatuses[device.devicePid] === 'open'} 
                              />
                              <label>열림</label>
                            </p>
                            <p>
                              <input 
                                type="radio" 
                                name={`status-${device.devicePid}`}
                                value="0" 
                                onChange={(e) => handleRemoteStatusChange(device.devicePid, e.target.value)} 
                                checked={remoteStatuses[device.devicePid] === 'close'} 
                              />
                              <label>닫힘</label>
                            </p>
                          </div>
                          <div className="lpopBtn">
                            <Button 
                              onClick={() => onClickRemote(device.devicePid)} 
                              className="FxButton"
                            >
                              제어
                            </Button>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="noData">
                        <p>제어 가능한 밸브가 없습니다.</p>
                      </div>
                    )}
                    </div>
                    <div className="lpopBtn">
                      <Button onClick={remotePopupClose} className="FxButton">닫기</Button>
                    </div>
                  </div>
                </div>
              </div>
            </Modal>
          ) : null}
          <div className="grayBox">
            <div className="gb_title noFlex">
              <h2>당일 에너지 공급량</h2>
            </div>
            <ul class="noChartDataNew">
              {airYn &&
                <li>
                  <b>압축공기</b>
                  <strong>
                  {inlo.airSource === 'Y'? getTodayTotalProd("AIR"): '0'}<em>Nm<sup>3</sup></em>
                  </strong>
                </li> }
              {steamYn &&
                <li>
                  <b>스팀</b>
                  <strong>
                  {inlo.steamSource === 'Y'? getTodayTotalProd("STEAM"): '0'}<em> kg</em>
                  </strong>
                </li>}                 
            </ul>
            <div>
            </div>
            <div className="gb_title mt20 noFlex">
              <h2>당월 에너지 공급량</h2>
              <div className="fs12">
                <span className="unit">(사용기간 {period})</span>
              </div>
            </div>            
            <ul class="noChartDataNew">
            {airYn &&
                <li>
                  <b>압축공기</b>
                  <strong>
                  {inlo.airSource === 'Y'? getMonthTotalProd("AIR"): '0'}<em>Nm<sup>3</sup></em>
                  </strong>
                </li> }
              {steamYn &&
                <li>
                  <b>스팀</b>
                  <strong>
                  {inlo.steamSource === 'Y'? getMonthTotalProd("STEAM"): '0'}<em> kg</em>
                  </strong>
                </li>}              
            </ul>           
          </div>
        </div>
        <div className="gridGroup mb20">
          {makeRealtimeEpwrGasHtml()}
          <div className="grayBox">
            <div className="gb_title noFlex">
              <h2>당일 에너지 사용량</h2>
            </div>
            <ul class="noChartDataNew">
              {airYn &&
                <li>
                  <b>압축공기</b>
                  <strong>
                    {inlo.airSink === 'Y' ? getTodayTotalCons("AIR") : '0'}<em>Nm<sup>3</sup></em>
                  </strong>
                </li>}
              {steamYn &&
                <li>
                  <b>스팀</b>
                  <strong>
                    {inlo.steamSink === 'Y' ? getTodayTotalCons("STEAM") : '0'}<em> kg</em>
                  </strong>
                </li>}
              {epwrYn &&
                <li>
                  <b>전기(사업장)</b>
                  <strong>
                    {inlo.epwrSink === 'Y' ? getTodayTotalCons("EPWR_15") || getTodayTotalCons("EPWR") : '0'}<em>kWh</em>
                  </strong>
                </li>}
              {gasYn &&
                <li>
                  <b>가스(보일러)</b>
                  <strong>
                    {inlo.gasSink === 'Y' ? getTodayTotalCons("GAS") : '0'}<em> Nm3</em>
                  </strong>
                </li>}
            </ul>
            <div className="gb_title mt20 noFlex">
              <h2>당월 에너지 사용량</h2>
              <div className="fs12">
                <span className="unit">(사용기간 {period})</span>
              </div>
            </div>
            <ul class="noChartDataNew">
              {airYn &&
                <li>
                  <b>압축공기</b>
                  <strong>
                    {inlo.airSink === 'Y' ? getMonthTotalCons("AIR") : '0'}<em>Nm<sup>3</sup></em>
                  </strong>
                </li>}
              {steamYn &&
                <li>
                  <b>스팀</b>
                  <strong>
                    {inlo.steamSink === 'Y' ? getMonthTotalCons("STEAM") : '0'}<em> kg</em>
                  </strong>
                </li>}
              {epwrYn &&
                <li>
                  <b>전기(사업장)</b>
                  <strong>
                    {inlo.epwrSink === 'Y' ? getMonthTotalCons("EPWR") : '0'}<em>kWh</em>
                  </strong>
                </li>}
              {gasYn &&
                <li>
                  <b>가스(보일러)</b>
                  <strong>
                    {inlo.gasSink === 'Y' ? getMonthTotalCons("GAS") : '0'}<em> Nm3</em>
                  </strong>
                </li>}            
            </ul>
          </div>
        </div>
        <div className="gridGroup mb20">
          <div className="grayBox">
            <div className="gb_title">
              <h2>공지사항</h2>
              <div className="fl_r" style={{verticalAlign: "bottom"}}>
                <a
                    href="#"
                    className="mini"
                    onClick={() => {
                      cmboardPopup();
                    }}
                >
                  more
                </a>
              </div>
            </div>
            <div className="tableBBS">
              <table>{getBoard("CMBOARD")}</table>
            </div>
            <FxmsPopup
                open={cmModalOpen}
                closeModal={closeCmModal}
                dialogTitle={cmboardPopObj.opTitle}
                opObj={cmboardPopObj}
            >
              <FxResource menu={cmboardPopObj}/>
            </FxmsPopup>

            <FxmsPopup
                open={feModalOpen}
                closeModal={closeFeModal}
                dialogTitle={feboardPopObj.opTitle}
                opObj={feboardPopObj}
            >
              <FxResource menu={feboardPopObj}/>
            </FxmsPopup>
          </div>
          <div className="grayBox span3">
            <div className="gb_title mb20">
              <h2>에너지 절감량</h2>
            </div>
            <table className="factory_energy">
              <tr>
                {(inlo.ownerInloNo===11000 || inlo.ownerInloNo===13000) &&
                  <td>
                    <div className="factory_flexData">
                      <h4>압축공기</h4>
                      <div>
                        {getSaveRate("AIR", "kWh")}
                      </div>
                    </div>
                    <div className="chartArea">
                      {" "}
                      <FxDashChart4
                        unit={"kWh"}
                        key={"에너지절감율 압축공기"}
                        energy={"AIR"}
                        ownerInloNo={inlo.ownerInloNo}
                        hardcodedValues={HARD_CODED_VALUES}
                        allValues={dataList7}
                      />
                    </div>
                  </td>}
                {(inlo.ownerInloNo===13000 || inlo.ownerInloNo===14000) &&
                  <td>
                    <div className="factory_flexData">
                      <h4>스팀</h4>
                      <div>
                        {getSaveRate("STEAM", "TOE")}
                      </div>
                    </div>
                    <div className="chartArea">
                      {" "}
                      <FxDashChart4
                        unit={"TOE"}
                        key={"에너지절감율 스팀"}
                        energy={"STEAM"}
                        ownerInloNo={inlo.ownerInloNo}
                        hardcodedValues={HARD_CODED_VALUES}
                        allValues={dataList7}
                      />{" "}
                    </div>
                  </td>}
              </tr>
            </table>
          </div>
          <div className="grayBox">
            <h2 className="mb20">계측기 현황</h2>
            <table className="numGroup">
              {airYn && getMeasur("AIR")}
              {steamYn && getMeasur("STEAM")}
              {epwrYn && getMeasur("EPWR")}            
            </table>
            {measurModal && (
                <DetailModal
                    engId={clickedEng}
                    cnt={clickedCnt}
                    setModal={setMeasurModal}
                    open={true}
                    complexInloNo={complex.complexInloNo}
                    plantInloNo={plantInloNo}
                />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
